/* lua.js generated code 0.3.0 */

require("clover/const/GamePropConst")
var userPropAddProp
function addUserPropAddPropCoin(propId, num, targetId, param, sceneName) {
    UserCoin.getInstance().addCoin(num)
}
function addUserPropAddPropEnergy(propId, num, targetId, param, sceneName) {
    UserEnergy.getInstance().addEnergy(num)
}
function addUserPropAddPropCash(propId, num, targetId, param, sceneName) {
    UserCash.getInstance().addCash(num)
}
function addUserPropAddPropEnergyInfOneHour(propId, num, targetId, param, sceneName) {
    UserEnergy.getInstance().addEnergyInfinity(3600000 * num)
}
function addUserPropAddPropEnergyInfTenMin(propId, num, targetId, param, sceneName) {
    UserEnergy.getInstance().addEnergyInfinity(600000 * num)
}
function addUserPropAddPropNamecard(propId, num, targetId, param, sceneName) {
    if (!BattlePassLogic.getInstance().isBattlePassAvaliable() ) return
    let userShow = UserManager.getInstance().getUserShowRef()
    let list = userShow.getCardList()
    userShow.addAndUseWithDressId(list, propId, BattlePassLogic.getInstance().config.end_time)
}
function addUserPropAddPropNameLabel(propId, num, targetId, param, sceneName) {
    if (!BattlePassLogic.getInstance().isBattlePassAvaliable()) return
    let userShow = UserManager.getInstance().getUserShowRef()
    let list = userShow.getLabelList()
    userShow.addAndUseWithDressId(list, propId, BattlePassLogic.getInstance().config.end_time)
}
function addUserPropAddPropEnergyMoreLimit(propId, num, targetId, param, sceneName) {
    if (!BattlePassLogic.getInstance().isBattlePassAvaliable()) return
    // let value = 20 
    //获取增加上限数
    // let value = MetaManager.getInstance().getPropMeta(propId).value
    let pastEnergy = UserEnergy.getInstance().getEnergy()[0]

    let propMeta = MetaManager.getInstance().getPropMeta(propId)
    let value = propMeta && propMeta.value || 0
    UserEnergy.getInstance().addEnergyLimit(tonumber(value), BattlePassLogic.getInstance().config.end_time)
    let newEnergy = UserEnergy.getInstance().getEnergy()[0]
    DCAssist.dc4BattlepassAddEnergy(pastEnergy, newEnergy)
    // let userShow = UserManager.getInstance().getUserShowRef()
    // userShow.useNameLabelId(propId)
}
UserPropAddPropFuncRef = table(
    [1, GamePropIds.kCoin, addUserPropAddPropCoin],
    [1, GamePropIds.kEnergy, addUserPropAddPropEnergy],
    [1, GamePropIds.kCash, addUserPropAddPropCash],
    [1, GamePropIds.kEnergyInf_1Hour, addUserPropAddPropEnergyInfOneHour],
    [1, GamePropIds.kEnergyInf_10Min, addUserPropAddPropEnergyInfTenMin],
    [1, GamePropIds.kNameCard, addUserPropAddPropNamecard], //通行证名片
    [1, GamePropIds.kNameDiamond, addUserPropAddPropNameLabel], //通行证钻石标识
    [1, GamePropIds.kAddEnergyLimit, addUserPropAddPropEnergyMoreLimit], //通行证加精力上限
)
function addUserPropAddPropSpecial(propId, num, targetId, param, sceneName) { }
function addUserPropAddPropIntoBag(propId, num, targetId, param, sceneName) {
    var meta = MetaManager.getInstance().getPropMeta(propId)
    if (UserPropData.isInfinitePreProp(propId)) {
        UserManager.getInstance().addInfiniteTimeProp(propId, num)
    }else if (UserPropData.isTimeProp(propId)) {
        UserManager.getInstance().addTimeProp(propId, num)
    } else {
        console.log("@@@@add user prop id:"+propId)
        UserManager.getInstance().addUserPropNumber(propId, num)
    }
}
function addUserPropAddPropPackage(propId, num, targetId, param, sceneName) {
    var meta = MetaManager.getInstance().getPropMeta(propId)
    if (!meta) {
        return 
    }
    var rewardList = meta.rewardList
    for (var k = 1, v = (rewardList || table())[1]; v; k++, v = (rewardList || table())[k]) {
        userPropAddProp(v.itemId, v.num, targetId, param, sceneName)
    }
}
function addUserPropAddPropLevelArea(propId, num, targetId, param, sceneName) { }
// 获取道具更新装扮信息
function addUserPropAddDress(propId, num, targetId, param, sceneName) {
    // 限时直接用当前时间加上expire_time 如果是expire_type那么就直接加上24小时 然后由特殊的请求返回更新真实数据 这里其实也就影响红点显示

    // let config  = DressManager.getInstance().getDressMsg(propId)
    // if (config.type == GameDressTypes.kHeadFrame){
        let dressMgr = DressManager.getInstance()
        dressMgr.addInfoById(propId)
        let homeScene = require("clover/scene/HomeScene").getInstance()
        if (homeScene) {
            homeScene.btnLayer && homeScene.btnLayer.updateBoxPrompt()
        }
    // }else if (config.type == GameDressTypes.kNameEffect){
    //     let userShow = UserManager.getInstance().getUserShowRef()
    //     let list = userShow.getNameEffectList()
    //     userShow.addAndUseWithDressId(list, propId, BattlePassLogic.getInstance().config.end_time)
    // }
    
}
UserPropAddTypeFuncRef = table(
    [1, GamePropTypes.kSpecial, addUserPropAddPropSpecial],
    [1, GamePropTypes.kPackage, addUserPropAddPropPackage],
    [1, GamePropTypes.kIntoBag, addUserPropAddPropIntoBag],
    [1, GamePropTypes.kLevelArea, addUserPropAddPropLevelArea],
    [1, GamePropTypes.kDress, addUserPropAddDress],
    
)
userPropAddProp = function (propId, num, targetId, param, sceneName) {
    if (UserPropAddPropFuncRef[propId]) {
        UserPropAddPropFuncRef[propId](propId, num, targetId, param, sceneName)
        return 
    }
    var propType = Math.floor(propId / GamePropTypeConst)
    if (UserPropAddTypeFuncRef[propType]) {
        UserPropAddTypeFuncRef[propType](propId, num, targetId, param, sceneName)
        return 
    }
    // TODO: 没有处理的添加道具的方式
}
module.exports = userPropAddProp
